import styles from "./style.module.scss";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import ArrowRight from "@components/shared/bestBuyers/icons/ArrowRight";
import { useQuery } from "@tanstack/react-query";
import { GQLOffers, GQLUrls } from "@gql/types/gql";
import Link from "@components/shared/linkNoPrefetch";
import { resolveURL } from "@lib/sharedUtils";

export default function BuyerDetails({ buyer }: { buyer: GQLOffers }) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <>
            <div className="flex items-center justify-between lg:mt-3 mt-6 ">
                <div className={`${styles["buyerDetailsShow"]}`}>
                    <Link href={`${resolveURL(buyer.url as GQLUrls)}`}>
                        <div className="flex items-center cursor-pointer ">
                            <div
                                className={`${styles["reviewColor"]}  font-extrabold text-sm   leading-3`}
                            >
                                {`${translate(
                                    translations,
                                    "several_general_readWord",
                                )} ${buyer.name as string} ${translate(
                                    translations,
                                    "several_general_reviewWord",
                                )}`}
                                <ArrowRight />
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    );
}
